import "./Insights.module.css";
import Header from "@/reusable_sections/Header";
import TourismIntelligence from "./sections/TourismIntelligence";
import NewsletterSubscription from "./sections/NewsletterSubscription";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Header />
      <TourismIntelligence />
      <NewsletterSubscription />
      <SecurityIntelligenceFooter />
    </div>;
}